import { Typography } from "@mui/material";
import AutomationApprovalSummary from "./AutomationApprovalSummary";
import AutomationSetupActions from "./AutomationSetupActions";
import AutomationSetupBlockers from "./AutomationSetupBlockers";
import AutomationSummaryCard from "./AutomationSummaryCard";

export default function AutomationSetupReady({ setup, days, setDays, activate, title }) {
  const approvalRequired = setup.cards.length > 0;
  const blockers = Array.isArray(setup.blockers) ? setup.blockers : [];
  return (
    <>
      {approvalRequired ? (
        <>
          <Typography>
            Review this permission before turning the automation on.
          </Typography>
          <AutomationSummaryCard title={title} setup={setup} />
          {setup.cards.map((card) => (
            <AutomationApprovalSummary key={card.action_id} card={card} />
          ))}
          <Typography variant="body2" color="text.secondary">
            No emails or other writes will happen until you approve and activate
            it.
          </Typography>
        </>
      ) : (
        <>
          <AutomationSummaryCard title={title} setup={setup} />
        </>
      )}
      {blockers.length ? (
        <AutomationSetupBlockers
          blockers={blockers}
          retry={() => setup.preparation?.mutate()}
          retrying={setup.preparation?.isPending}
        />
      ) : (
        <AutomationSetupActions
          approvalRequired={approvalRequired}
          {...{ days, setDays, activate }}
          pending={setup.mutation.isPending}
        />
      )}
    </>
  );
}
